<template>
  <div>
    <sale-plan-count-list v-show="action === 'list'" @change-action="changeAction" />
    <sale-plan-count-detail v-if="action === 'detail'" :row-data="rowData" @change-action="changeAction" />
  </div>
</template>

<script>
import SalePlanCountList from './components/salePlanCountList.vue'
import SalePlanCountDetail from './components/salePlanCountDetail.vue'
export default {
  components: {
    SalePlanCountList,
    SalePlanCountDetail
  },
  data() {
    return {
      action: 'list',
      rowData: {}
    }
  },
  created() {

  },
  methods: {
    changeAction(type, rowData) {
      this.action = type
      this.rowData = rowData || {}
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanCountList.vue